
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Ernst K., verstorben am 20. Oktober 2020</b>
    <br />
    <br />
    <i>Seine Ehefrau erzählt:</i>
    <br />
    <p>
  «Wir haben uns beide immer sehr genau an die Regeln gehalten. Trotzdem habe
  ich mich angesteckt. Ich weiss nicht, warum oder wo das passiert ist. Aber ich
  mag mich nicht hintersinnen. Es ist schon so schwer genug im Moment, und
  eigentlich will ich gar nichts mehr hören von diesem Virus.
    </p>
    <p>
  Ich habe so gut aufgepasst, dass er es nicht auch bekommt. Wir haben ja genau
  gewusst, dass es bei ihm schlimm enden kann. Das hatte auch der Arzt so
  gesagt. Denn Ernst war schon vorher geschwächt und hatte Probleme mit dem
  Herz. Trotzdem ist es jetzt genau so gekommen. Das ist für mich nur schwer zu
  ertragen. Zum Glück habe ich jemanden, der jetzt oft zu mir kommt und nach mir
  schaut.
    </p>
    <p>
  Ich verstehe, dass die Leute wieder normal leben wollen, ohne Einschränkungen.
  Das Leben muss weitergehen. Ernst war ja nicht mehr der Jüngste, und wir haben
  geahnt, dass irgendwann etwas kommen wird. Trotzdem schmerzt es im Moment
  sehr. Ich könnte viel über ihn erzählen. Eigentlich war er einfach ein guter
  Mensch. Er war Bäckermeister und hat in seinem Leben viel weitergegeben, immer
  wieder Lehrlinge ausgebildet. Das wird von ihm bleiben.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;